import {
  AssetCategory,
  AssetContainerType,
  AssetItem,
  WaiverInfoType,
} from 'src/api/api-types/assets';
import { AccountLookup } from 'src/api/api-types/lookups';
import { CreatedByType } from 'src/api/api-types/user';
import { ItemIdType, ItemType } from '../../types';
import { removeTimezone } from '../../utils/date';

export class Asset {
  readonly id: number;
  readonly generatorId: string;
  readonly minervaId: string;
  readonly reference: string;
  readonly account: AccountLookup;
  readonly createdAt: Date | string;
  readonly createdBy?: CreatedByType;
  readonly updatedAt?: Date | string;
  readonly updatedBy?: CreatedByType;
  readonly client: ItemType;
  readonly generator: ItemType;
  readonly jurisdiction: ItemType;
  readonly agency: ItemType;
  readonly hauler: ItemType;
  readonly accountType: ItemType;

  readonly updateDescription?: boolean;
  readonly isActive?: boolean;
  readonly category?: AssetCategory;
  readonly subCategory?: AssetCategory;
  readonly containerTypes?: AssetContainerType[];
  readonly shortText: string;
  readonly type?: ItemType;
  readonly description: string;
  readonly descriptionTruncated: boolean;
  readonly relatedLookupsName?: string;
  readonly dateIssued: Date | string | null;
  readonly relatedTo?: ItemType | null;
  readonly relatedToType?: ItemType | null;
  readonly totalAttachments: number;
  readonly canUpdate: boolean;
  readonly status?: ItemIdType;
  readonly user?: ItemIdType;
  readonly priority?: ItemIdType;
  readonly assetDate?: Date | string | null;
  readonly isRelatedEntityActive: boolean;
  readonly waiverInfo?: WaiverInfoType;
  readonly waiverInfoStatusId?: string | number | null;
  readonly waiverInfoFollowUpDate?: WaiverInfoType['followUpDate'];

  readonly dueDate?: Date | string | null;
  readonly overdue?: boolean | null;

  constructor(asset: AssetItem) {
    const {
      id,
      type,
      category,
      subCategory,
      containerTypes,
      shortText,
      description,
      descriptionTruncated,
      relatedTo,
      relatedToType,
      client,
      hauler,
      jurisdiction,
      agency,
      totalAttachments,
      updatedAt,
      updatedBy,
      createdAt,
      createdBy,
      dateIssued,
      minervaId,
      reference,
      generatorId,
      isActive,
      account,
      generator,
      accountType,
      canUpdate,
      isRelatedEntityActive,
      waiverInfo,
      status,
      user,
      priority,
      assetDate,
      dueDate,
      overdue,
    } = asset;

    this.id = id;
    this.minervaId = minervaId;
    this.reference = reference;
    this.generatorId = generatorId;
    this.type = type;
    this.isActive = isActive;
    this.generator = generator;
    this.account = account;
    this.category = category;
    this.subCategory = subCategory;
    this.containerTypes = containerTypes;
    this.shortText = shortText || '';
    this.description = description || '';
    this.descriptionTruncated = descriptionTruncated ?? false;
    this.dateIssued = dateIssued || null;
    this.createdAt = createdAt || '';
    this.createdBy = createdBy;
    this.updatedAt = updatedAt || '';
    this.updatedBy = updatedBy;
    this.client = client;
    this.hauler = hauler;
    this.accountType = accountType;
    this.jurisdiction = jurisdiction;
    this.agency = agency;
    this.totalAttachments = totalAttachments;
    this.relatedTo = relatedTo || null;
    this.relatedToType = relatedToType || null;
    this.canUpdate = canUpdate;
    this.isRelatedEntityActive = isRelatedEntityActive;
    this.waiverInfo = waiverInfo;
    this.waiverInfoStatusId = waiverInfo?.status.id || null;
    this.waiverInfoFollowUpDate = waiverInfo?.followUpDate || null;
    this.status = status;
    this.user = user;
    this.priority = priority;
    this.assetDate = removeTimezone(assetDate);
    this.dueDate = removeTimezone(dueDate);
    this.overdue = overdue;
  }
}
